import { render, staticRenderFns } from "./GlobalCategoryProductsCarousel.vue?vue&type=template&id=59b11b67&name=global-category-products-carousel&"
import script from "./GlobalCategoryProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./GlobalCategoryProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCategoryProductsCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports